import {svgInfoRU16Tl} from '../../SvgCode'

export default class infoRUTl{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-ru');
        _parent.innerHTML= `
          <div class="info-inner">
            <span class="info-img">${svgInfoRU16Tl}</span>
          </div>
        `;
    }
}
